import { styled } from '@arpeggi/ui'

export const EmptyStateText = styled('div', {
  font: 'dm',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '28px',
  margin: '20px 0px',
  variants: {
    muted: {
      true: {
        color: '$gray0600'
      }
    }
  }
})
